import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/UI/Button';
import { Box } from '@/layout';
import { Modal } from '@mui/material';

import { ModalActions, ModalForm, ModalTitle } from '../style';
import { successHandler, errorHandler } from '@/utils/toastHandler';
import { Close } from '@/components/Icon';
import { InputWrapper } from '@/components/Container/AuthContainer/styles';
import { TextField } from '@mui/material';
import { renameFolder } from '@/api/document.api';
import { useEffect } from 'react';

interface TranscribeProps {
  folderId: string;
  currentFolderId: number | null;
  show: boolean;
  setShowRenameFolderModal: (show: boolean) => void;
  getDocuments: (id: number | null) => void;
  folderName: string;
}

const RenameModal = ({ folderName, folderId, currentFolderId, show, setShowRenameFolderModal, getDocuments }: TranscribeProps) => {
  // @ts-ignore
  const { t } = useTranslation();

  const {
    control,
    resetField,
    setValue,
    handleSubmit
  } = useForm<{ name: string }>();

  const onSubmit = handleSubmit(async (data) => {
    try {
      // trim後若為空字串則不允許送出
      if (data.name.trim() === '') {
        errorHandler('Folder name cannot be empty');
        return;
      }
      const res = (await renameFolder({ newName: data.name.trim(), folderId: folderId })).data;
      if (res.success) {
        getDocuments(currentFolderId);
        // successHandler(t('success.addFolder'));
        successHandler('Rename Folder Success');
        resetField('name');
        setShowRenameFolderModal(false);
      }
    } catch (error: any) {
      console.log(error);
      errorHandler('Rename Folder Failed: ' + error.response.data.data);
    } finally {

    }
  });

  useEffect(() => {
    setValue('name', folderName);
  }, [show]);

  return (
    <Modal
      open={show}
      onClose={() => setShowRenameFolderModal(false)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableEnforceFocus
    >
      <ModalForm onSubmit={onSubmit}>
        <Close.ButtonClose
          type="button"
          onClick={() => {
            setShowRenameFolderModal(false);
          }}
        >
          <Close.CloseSVG />
        </Close.ButtonClose>
        <ModalTitle>Rename folder</ModalTitle>
        <InputWrapper style={{ height: 'auto' }}>
          <Controller
            control={control}
            name={'name'}
            defaultValue={''}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                label={t('form.name.label')}
                variant="standard"
                value={value}
                sx={{ width: '100%' }}
                onChange={onChange}
                error={!!error}
                helperText={error ? error.message : null}
                autoComplete="off"
              />
            )}
          />
        </InputWrapper>
        <ModalActions>
          <Button type="submit" size={'lg'} variant={'primary'} rounded={false}>
            {t('buttons.ok')}
          </Button>
          <Button
            type="button"
            size={'lg'}
            variant={'primary-invert'}
            color="primary"
            onClick={() => setShowRenameFolderModal(false)}
            style={{ textDecoration: 'underline' }}
          >
            {t('buttons.cancel')}
          </Button>
        </ModalActions>
      </ModalForm>
    </Modal>
  );
};

export default RenameModal;
